import { Card, Divider, Grid, Stack, Typography, useTheme } from "@mui/material";
import ProfileDetails from "./profileDetails";
import ProfilePic from "./profilePic";
import ProfileLogout from "./profileLogout";
import ProfileVersion from "./profileVersion";
import { useGetProfileDetailsMutation } from "../../services/profileApi";
import { useEffect, useCallback } from "react";
import { GetAuth } from "../../context/auth/authProvider";
import ErrorView from '../error/errorView';

const ProfileWebView = () => {
    const theme = useTheme();

    const auth = GetAuth();

    const [
        getProfileData, 
        {
            isLoading: isLoadingGetProfileData,
            isSuccess: isSuccessGetProfileData,
            data: profileData,
            isError: isErrorGetProfileData,
            error: errorGetProfileData
        }
    ] = useGetProfileDetailsMutation();

    useEffect(() => {
        if(isSuccessGetProfileData && profileData){
            console.log(profileData);
        }
    }, [isSuccessGetProfileData, profileData]);

    useEffect(() => {
        if(auth?.currentUser){
            getProfileData();
        }
    }, [auth]);

    const loadLatestProfileDetails = useCallback(() => {
        getProfileData();
    }, [auth]);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                ml={10}
                px={12}
                pt={11}
                sx={{
                    display: {xs: 'none', lg: 'block'}
                }}
            >
                <Typography
                    fontWeight={800}
                    fontSize={{md: 32, lg: 50}}
                    letterSpacing={0.36}
                    color={theme.palette.primary.main}
                >
                    Profile
                </Typography>

                <Typography
                    fontWeight={400}
                    fontSize={{md: 16, lg: 25}}
                    letterSpacing={0.5}
                    color="#5E5959"
                    pb={3}
                >
                    View all profile details here
                </Typography>

                <Divider sx={{width: '100%'}}/>

                {
                    isErrorGetProfileData
                    ?
                    <Stack pb={10}>
                        <ErrorView 
                            errorTitle="Oops!"
                            errorDescription={errorGetProfileData?.data?.message ?? "Something went wrong"}
                            icon="/images/error.png"
                            height="50vh"
                        />

                        <ProfileLogout width="fit-content"/>
                    </Stack>
                    :
                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='start'
                        py={9}
                        container
                        spacing={2}
                    > 
                        <Grid size={{xs: 5}}>
                            <Card
                                sx={{
                                    width: '100%'
                                }}
                            >
                                <ProfilePic 
                                    data={profileData}
                                    isLoading={isLoadingGetProfileData}
                                    loadLatestProfileDetails={loadLatestProfileDetails}
                                />
                            </Card>
                        </Grid>

                        <Grid size={{xs: 7}}>
                            <Stack
                                direction='column'
                                justifyContent='center'
                                alignItems='center'
                                width='100%'
                                spacing={{xs: 2, md: 2}}
                            >
                                <ProfileDetails 
                                    data={profileData}
                                    isLoading={isLoadingGetProfileData}
                                    loadLatestProfileDetails={loadLatestProfileDetails}
                                />

                                <ProfileLogout />
                            </Stack>
                        </Grid>
                    </Grid>
                }

                <ProfileVersion />
            </Stack>
        </>
    );
}

export default ProfileWebView;